/**
 * A way to stop every running scene before React repaints.
 *
 * ROUND 13 C2. While the 3D scene ran, a real click on the top
 * navigation took 3,115 ms at 5,000 configuration items and 9,165 ms at
 * 20,000; the Twin's own tab strip took 1,485 ms and then 38,585 ms;
 * and the 2D/3D toggle took 18.4 seconds at 5,000 and DID NOT ANSWER AT
 * ALL at 20,000, timing out with the button visible, enabled and
 * stable. In one run at 20,000 items forty-eight separate clicks on the
 * product's own navigation did not complete. A reader who enters the 3D
 * constellation at bank scale cannot press the button that gets them
 * out.
 *
 * The frame budget was doing its job and could not help: it caps the
 * SHARE of the wall clock the loop may occupy, and when a single frame
 * costs a second there is no share small enough to leave the main
 * thread responsive within a click's patience.
 *
 * So the toggle stops competing with the scene and tears it down first.
 * This is a module-level flag rather than a prop because the thing that
 * needs to stop is a `requestAnimationFrame` loop owned by an imperative
 * handle, and the thing that needs to stop it is a React event handler
 * three components away; threading a ref through that is more coupling
 * than a halt signal, not less.
 *
 * The scene's own `running` flag stays: it is about visibility, and this
 * is about a deliberate exit.
 */
let halted = false;

/** Stop every scene loop at its next frame. Call BEFORE the state
 *  change that will unmount it. */
export function haltScenes(): void {
  halted = true;
}

/** Let scenes run again. Called when one mounts, so a halt cannot
 *  outlive the navigation that caused it. */
export function resumeScenes(): void {
  halted = false;
}

export function scenesHalted(): boolean {
  return halted;
}
